import _objectSpread from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
/* eslint-disable */
import editorStyle from "../util/defaultStyle";
import { Marker } from '@antv/g-canvas/lib/shape';
export default function (G6) {
  G6.registerBehavior('dragEdge', {
    getDefaultCfg: function getDefaultCfg() {
      return {
        updateEdge: true,
        delegate: true,
        delegateStyle: {},
        dragEdge: false
      };
    },
    getEvents: function getEvents() {
      return {
        'anchor:dragstart': 'onDragStart',
        'anchor:drag': 'onDrag',
        'anchor:dragend': 'onDragEnd',
        'anchor:dragenter': 'onDragEnter',
        'anchor:dragleave': 'onDragLeave'
      };
    },
    onDragEnter: function onDragEnter(e) {
      if (!this.origin) {
        return;
      }
      if (!this.sameNode(e)) {
        e.item.setHotspotActived(true);
        this.origin.targetNode = e.target.getParent().getParent().get('item');
        this.origin.targetAnchor = e.item.get('index');
      }
    },
    onDragLeave: function onDragLeave(e) {
      if (!this.origin) {
        return;
      }
      if (!this.sameNode(e)) {
        e.item.setHotspotActived(false);
        this.origin.targetNode = null;
        this.origin.targetAnchor = null;
      }
    },
    onDragStart: function onDragStart(e) {
      var node = e.target.getParent().getParent().get('item');
      var anchorIndex = e.item.get('index');
      var point = node.getAnchorPoints()[anchorIndex];
      this.target = e.item;
      var groupId = node.get('groupId');
      if (groupId) {
        var subProcessNode = e.target.getParent().getParent().getParent().getParent().get('item');
        var subProcessBBox = subProcessNode.getBBox();
        this.origin = {
          x: point.x + subProcessBBox.x + subProcessBBox.width / 2,
          y: point.y + subProcessBBox.y + subProcessBBox.height / 2,
          sourceNode: node,
          sourceAnchor: anchorIndex
        };
        this.dragEdgeBeforeShowAnchorBySub(subProcessNode);
      } else {
        this.origin = {
          x: point.x,
          y: point.y,
          sourceNode: node,
          sourceAnchor: anchorIndex
        };
        this.dragEdgeBeforeShowAnchor(e);
      }
      this.graph.set('edgeDragging', true);
    },
    onDrag: function onDrag(e) {
      if (!this.origin) {
        return;
      }
      this._updateEdge(this.target, e);
    },
    onDragEnd: function onDragEnd(e) {
      if (!this.origin) {
        return;
      }
      var delegateShape = e.item.get('edgeDelegate');
      if (delegateShape) {
        delegateShape.remove();
        this.target.set('edgeDelegate', null);
      }
      this._updateEdge(this.target, e, true);
      this.graph.setItemState(this.origin.sourceNode, 'show-anchor', false);
      this.target = null;
      this.origin = null;
      this.graph.set('edgeDragging', false);
    },
    sameNode: function sameNode(e) {
      return e.target instanceof Marker && e.target.getParent() && e.target.getParent().getParent().get('item').get('id') === this.origin.sourceNode.get('id');
    },
    dragEdgeBeforeShowAnchorBySub: function dragEdgeBeforeShowAnchorBySub(subProcessNode) {
      var group = subProcessNode.getContainer();
      group.nodes.forEach(function (a) {
        var aGroup = a.getContainer();
        aGroup.showAnchor();
        aGroup.anchorShapes.forEach(function (b) {
          return b.get('item').showHotpot();
        });
      });
    },
    dragEdgeBeforeShowAnchor: function dragEdgeBeforeShowAnchor(e) {
      var sourceGroupId = this.origin.sourceNode.getModel().groupId;
      this.graph.getNodes().forEach(function (node) {
        if (node.getModel().clazz === 'start' || node.getModel().clazz === 'timerStart' || node.getModel().clazz === 'messageStart') return;
        var targetGroupId = node.getModel().groupId;
        if (!sourceGroupId && targetGroupId || sourceGroupId && !targetGroupId || sourceGroupId !== targetGroupId) return;
        var group = node.getContainer();
        group.showAnchor();
        group.anchorShapes.forEach(function (a) {
          return a.get('item').showHotpot();
        });
      });
    },
    _updateEdge: function _updateEdge(item, e, force) {
      var x = e.x;
      var y = e.y;
      if (this.delegate && !force) {
        this._updateEdgeDelegate(item, x, y);
        return;
      }
      var node = e.target.getParent().getParent().get('item');
      var groupId = node.get('groupId');
      if (groupId) {
        this._addSubProcessEdge(node, e);
      } else {
        this._addEdge(e);
      }
      this._clearAllAnchor();
      this.graph.paint();
    },
    _updateEdgeDelegate: function _updateEdgeDelegate(item, x, y) {
      var self = this;
      var edgeShape = item.get('edgeDelegate');
      if (!edgeShape) {
        var parent = self.graph.get('group');
        edgeShape = parent.addShape('line', {
          attrs: _objectSpread({
            x1: this.origin.x,
            y1: this.origin.y,
            x2: x,
            y2: y
          }, editorStyle.edgeDelegationStyle)
        });
        edgeShape.set('capture', false);
        item.set('edgeDelegate', edgeShape);
      }
      edgeShape.attr({
        x2: x,
        y2: y
      });
      this.graph.paint();
    },
    _clearAllAnchor: function _clearAllAnchor() {
      this.graph.getNodes().forEach(function (node) {
        var group = node.getContainer();
        group.clearAnchor();
      });
    },
    _addSubProcessEdge: function _addSubProcessEdge(node, e) {
      if (this.origin.targetNode) {
        var group = node.getContainer().getParent().getParent();
        var subProcess = node.getContainer().getParent().getParent().get('item');
        var sourceId = this.origin.sourceNode.get('id');
        var targetId = this.origin.targetNode.get('id');
        var addModel = {
          id: sourceId + '_to_' + targetId,
          clazz: 'flow',
          source: sourceId,
          target: targetId,
          sourceAnchor: this.origin.sourceAnchor,
          targetAnchor: this.origin.targetAnchor
        };
        var resultModel = group.addEdgeModel(subProcess, addModel);
        if (this.graph.executeCommand) {
          this.graph.executeCommand('update', {
            itemId: subProcess.get('id'),
            updateModel: resultModel
          });
        } else {
          this.graph.updateItem(node, resultModel);
        }
      }
    },
    _addEdge: function _addEdge() {
      if (this.origin.targetNode) {
        var timestamp = new Date().getTime();
        var addModel = {
          id: 'flow' + timestamp,
          clazz: 'flow',
          source: this.origin.sourceNode.get('id'),
          target: this.origin.targetNode.get('id'),
          sourceAnchor: this.origin.sourceAnchor,
          targetAnchor: this.origin.targetAnchor
        };
        if (this.graph.executeCommand) {
          this.graph.executeCommand('add', {
            type: 'edge',
            addModel: addModel
          });
        } else {
          this.graph.add('edge', addModel);
        }
      }
    }
  });
}